
// import upArrow from "assets/images/organisationProfile/setup/select arrow.svg";
// import upArrowdark from "assets/images/organisationProfile/setup/selectArowdark.svg";
// import React, { useEffect, useRef, useState } from "react";
// import GetActionIcon from "constants/Homepage/ysafe/iconFunctions/getActionIcon";
// import useTheme from "hooks/observer";
// import SquareCheckBox from "components/SquareCheckBox/index";
// import "./CreateTeams.scss";
// import Button from "components/Button/index";

// const CreateTeams = ({ updateOperations, initialOperations = [] }) => {
//   const theme = useTheme();
//   const arrow = theme === "light" ? upArrow : upArrowdark;

//   const [isDropdownOpen, setIsDropdownOpen] = useState(false);
//   const [selectedTeams, setSelectedTeams] = useState([]);

//   const [searchTerm, setSearchTerm] = useState("");
//   const [hasSelectionBeenConfirmed, setHasSelectionBeenConfirmed] = useState(
//     !!initialOperations.length
//   );
//   const [dropdownData, setDropdownData] = useState([]); // State for API-fetched data
//   const [checkedStates, setCheckedStates] = useState([]);
//   const dropdownRef = useRef(null);
//  useEffect(() => {
//     const fetchTeams = async () => {
//       try {
//         await init();
//         const teams = await Team.list_teams();
        
//         const data = teams.map(team => ({ team }));
//         setDropdownData(data);
//         setCheckedStates(data.map((t) => initialOperations?.includes(t.team) || false));
//       } catch (error) {
//         console.error("Error fetching teams:", error);
//       }
//     };
//     fetchTeams();
//   }, [initialOperations]);

//   const handleCheckboxChange = (index) => {
//     const newCheckedStates = [...checkedStates];
//     newCheckedStates[index] = !newCheckedStates[index];
//     setCheckedStates(newCheckedStates);
//   };

//   const truncateName = (name) => {
//     const parts = name.split(" ");
//     if (parts.length > 1) {
//       return `${parts[0]} ${parts[1].charAt(0)}...`;
//     }
//     return name.length > 8 ? `${name.substring(0, 8)}...` : name;
//   };

//   const selectedRoles = dropdownData.filter((_, index) => checkedStates[index]);

//   const filteredDropdownData = dropdownData?.filter((role) =>role.team.toLowerCase().includes(searchTerm.toLowerCase())
//   );
//   console.log("filteredDropdownData", filteredDropdownData);

//   const renderSelectedRoles = () => (
//     <div className="selected-users-container">
//       {!hasSelectionBeenConfirmed ? (
//         <>
//           <input
//             type="text"
//             placeholder="Select Teams"
//             className="user-input"
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             onFocus={() => setIsDropdownOpen(true)}
//           />
//           <img
//             src={arrow}
//             alt="arrow"
//             className="dropdown-arrow"
//             onClick={() => setIsDropdownOpen(!isDropdownOpen)}
//           />
//         </>
//       ) : (
//         <>
//           <div className="user-chips">
//                         {selectedTeams.slice(0, 1).map((role, index) => (
//                 <span key={index} className="user-chip">
//                   {truncateName(role.team)}
//                 </span>
//               ))}
//               {selectedTeams.length > 1 && (
//                 <span className="remaining-count">
//                   +{selectedTeams.length - 1}
//                 </span>
//               )}
//           </div>
//           <div
//             className="cross"
//             onClick={() => {
//               setCheckedStates(Array(dropdownData.length).fill(false));
//               setSearchTerm("");
//               setHasSelectionBeenConfirmed(false);
//             }}
//           >
//             <GetActionIcon
//               type="cross"
//               color={theme === "light" ? "#7D708A" : "#BDB8C2"}
//             />
//           </div>
//         </>
//       )}
//     </div>
//   );

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsDropdownOpen(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   return (
//     <div className="CreateTeamRoles">
//       <div className="CreateTeamRolesWrapper">
//         <div className="CreateTeamRolesWrapperContent" ref={dropdownRef}>
//           <p>Add Teams</p>
//           <div className="CreateTeamRolesselectUser">
//             <div className="user" onClick={() => setIsDropdownOpen(true)}>
//               {renderSelectedRoles()}
//             </div>
//             {isDropdownOpen && (
//               <div className="RolesDropdown">
//                 <ul style={{height: "inherit"}}>
//                   {filteredDropdownData.map((option, index) => (
//                     <li
//                       key={index}
//                       className="NotificationItem"
//                       onClick={() => handleCheckboxChange(index)}
//                     >
//                       <SquareCheckBox
//                         labelStyles={{
//                           color: "var(--text-grey-strong)",
//                           fontFamily: "Helvetica, sans-serif"
//                         }}
//                         isChecked={checkedStates[index]}
//                         handleCheck={() => handleCheckboxChange(index)}
//                       />
//                       <div className="content">
//                         <p>{option.team}</p>
//                       </div>
//                     </li>
//                   ))}
//                 </ul>
//                 <div className="RolesDropdownButtons">
//                   <Button
//                     type="white"
//                     title="Clear"
//                     width="50%"
//                     onClick={() => {
//                                 setCheckedStates(Array(dropdownData.length).fill(false));
//                                 setSearchTerm("");
//                                 setHasSelectionBeenConfirmed(false);
//                                 setSelectedTeams([]); // Clear selected teams too
//                       }}

//                   />
//                  <Button
//                     type="violet"
//                     title="Select"
//                     width="50%"
//                     onClick={() => {
//                       const newlySelected = dropdownData.filter((_, index) => checkedStates[index]);
//                       setSelectedTeams(newlySelected);
//                       setIsDropdownOpen(false);
//                       setHasSelectionBeenConfirmed(true);
//                       updateOperations(newlySelected);
//                     }}
//                   />

//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CreateTeams;


import upArrow from "assets/images/organisationProfile/setup/select arrow.svg";
import upArrowdark from "assets/images/organisationProfile/setup/selectArowdark.svg";
import React, { useEffect, useRef, useState } from "react";
import GetActionIcon from "constants/Homepage/ysafe/iconFunctions/getActionIcon";
import useTheme from "hooks/observer";
import SquareCheckBox from "components/SquareCheckBox/index";
import "./CreateTeams.scss";
import Button from "components/Button/index";
import { Team as IzTeam } from "@induz/sdk";

const CreateTeams = ({ updateOperations, initialOperations = [] }) => {
  const theme = useTheme();
  const arrow = theme === "light" ? upArrow : upArrowdark;

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [hasSelectionBeenConfirmed, setHasSelectionBeenConfirmed] = useState(
    !!initialOperations.length
  );
  const [dropdownData, setDropdownData] = useState([]);
  const [checkedStates, setCheckedStates] = useState([]);
  const [selectedTeams, setSelectedTeams] = useState(initialOperations.map(team => ({ team })));
  const dropdownRef = useRef(null);

  useEffect(() => {
    const fetchTeams = async () => {
      try {
        const teams = await IzTeam.listTeamNames();
        // Sort case-sensitively to help differentiate between similar names
        const sortedTeams = [...teams].sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "case" }));
        const data = sortedTeams.map(team => ({ team }));
        setDropdownData(data);
        setCheckedStates(data.map((t) => initialOperations?.some(i => i === t.team)));
      } catch (error) {
        console.error("Error fetching teams:", error);
      }
    };
    fetchTeams();
  }, [initialOperations]);

  const handleCheckboxChange = (index) => {
    const newCheckedStates = [...checkedStates];
    newCheckedStates[index] = !newCheckedStates[index];
    setCheckedStates(newCheckedStates);
  };

  const truncateName = (name) => {
    const parts = name.split(" ");
    if (parts.length > 1) {
      return `${parts[0]} ${parts[1].charAt(0)}...`;
    }
    return name.length > 8 ? `${name.substring(0, 8)}...` : name;
  };

  const filteredDropdownData = dropdownData.filter((role) =>
    role.team.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const renderSelectedTeams = () => (
    <div className="selected-users-container">
      {!hasSelectionBeenConfirmed ? (
        <>
          <input
            type="text"
            placeholder="Select Teams"
            className="user-input"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onFocus={() => setIsDropdownOpen(true)}
          />
          <img
            src={arrow}
            alt="arrow"
            className="dropdown-arrow"
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          />
        </>
      ) : (
        <>
          <div className="user-chips">
            {selectedTeams.slice(0, 1).map((role, index) => (
              <span key={index} className="user-chip">
                {truncateName(role.team)}
              </span>
            ))}
            {selectedTeams.length > 1 && (
              <span className="remaining-count">
                +{selectedTeams.length - 1}
              </span>
            )}
          </div>
          <div
            className="cross"
            onClick={() => {
              setCheckedStates(Array(dropdownData.length).fill(false));
              setSearchTerm("");
              setHasSelectionBeenConfirmed(false);
              setSelectedTeams([]);
            }}
          >
            <GetActionIcon
              type="cross"
              color={theme === "light" ? "#7D708A" : "#BDB8C2"}
            />
          </div>
        </>
      )}
    </div>
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="CreateTeamRoles">
      <div className="CreateTeamRolesWrapper">
        <div className="CreateTeamRolesWrapperContent" ref={dropdownRef}>
          <p>Add Teams</p>
          <div className="CreateTeamRolesselectUser">
            <div className="user" onClick={() => setIsDropdownOpen(true)}>
              {renderSelectedTeams()}
            </div>
            {isDropdownOpen && (
              <div className="RolesDropdown">
                <ul style={{ height: "inherit" }}>
                  {filteredDropdownData.map((option, index) => (
                    <li
                      key={option.team}
                      className="NotificationItem"
                      onClick={() => handleCheckboxChange(index)}
                    >
                      <SquareCheckBox
                        labelStyles={{
                          color: "var(--text-grey-strong)",
                          fontFamily: "Helvetica, sans-serif"
                        }}
                        isChecked={checkedStates[index]}
                        handleCheck={() => handleCheckboxChange(index)}
                      />
                      <div className="content">
                        <p>{option.team}</p>
                      </div>
                    </li>
                  ))}
                </ul>
                <div className="RolesDropdownButtons">
                  <Button
                    type="white"
                    title="Clear"
                    width="50%"
                    onClick={() => {
                      setCheckedStates(Array(dropdownData.length).fill(false));
                      setSearchTerm("");
                      setHasSelectionBeenConfirmed(false);
                      setSelectedTeams([]);
                    }}
                  />
                  <Button
                    type="violet"
                    title="Select"
                    width="50%"
                    onClick={() => {
                      const selected = dropdownData.filter((_, index) => checkedStates[index]);
                      setSelectedTeams(selected);
                      setIsDropdownOpen(false);
                      setHasSelectionBeenConfirmed(true);
                      updateOperations(selected);
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateTeams;
